import styled from 'styled-components';

import AppModal from '../../../../../../components/Modal';
import { px } from '../../../../../../contrib/ui';

const SetupNewSeasonModalStyled = styled(AppModal)`
  .modal-actions {
    button {
      max-width: fit-content !important;
      width: fit-content !important;
      span.button__label {
        width: ${px(350)};
      }
    }
  }
`;

export default SetupNewSeasonModalStyled;
